import React, { Children } from 'react';
import { MapPinIcon, UsersIcon, SearchIcon, ArrowRightIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export const USPBar: React.FC = () => {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 100
      }
    }
  };
  return <div className="w-full relative" data-id="element-738" data-mp="2fhxv5w1roxkx">
      {/* Blue background bar for the top half */}
      <div className="absolute top-0 left-0 w-full h-1/2 bg-[#004AC7] z-0" data-id="element-739" data-mp="2khsk3u1zfd3c"></div>
      <div className="absolute bottom-0 left-0 w-full h-1/2 z-0 bg-[#004AC7]" data-id="element-740" data-mp="2palouhxgalff"></div>

      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px] relative z-10 py-8" data-id="element-741" data-mp="1rtemhfet2isb">
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true
      }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-742" data-mp="1wshg83pc52kz">
          {/* Card 1 - Gevonden worden in de regio */}
          <motion.div variants={itemVariants} whileHover={{
          y: -5,
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
        }} className="bg-white rounded-xl p-6 shadow-lg transition-all duration-300 flex flex-col h-full border border-gray-100" data-id="element-743" data-mp="lf9gcbzji7qq">
            <div className="bg-[#EEF5FA] rounded-lg p-3 mb-5 inline-flex w-fit" data-id="element-744" data-mp="7jf9rzm8nugs">
              <MapPinIcon className="h-6 w-6 text-[#004AC7]" data-id="element-745" data-mp="2ldqbdkwht4s" />
            </div>
            <h3 className="font-bold text-[#111827] mb-3 text-lg leading-tight" data-id="element-746" data-mp="3ttrnmbhnpj9a">
              Gevonden worden in je eigen regio
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed mb-6 flex-grow" data-id="element-747" data-mp="1s1muwxsc2hxi">
              Wij werken voor ondernemers in Noord-Holland Noord en weten waar
              hun klanten zoeken. Een website die daarop aansluit, plus de
              vormgeving eromheen.
            </p>
            <a href="#services" className="inline-flex items-center text-[#004AC7] font-semibold text-sm hover:text-[#003A9E] transition-colors group mt-auto" data-id="element-748" data-mp="3hgxmh7y5hmth">
              Bekijk onze diensten
              <ArrowRightIcon className="ml-1.5 h-4 w-4 transform group-hover:translate-x-1 transition-transform" data-id="element-749" data-mp="38fziuqrmjhbf" />
            </a>
          </motion.div>

          {/* Card 2 - Buiten de via-via loop */}
          <motion.div variants={itemVariants} whileHover={{
          y: -5,
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
        }} className="bg-white rounded-xl p-6 shadow-lg transition-all duration-300 flex flex-col h-full border border-gray-100" data-id="element-750" data-mp="421c84tahrjr">
            <div className="bg-[#EEF5FA] rounded-lg p-3 mb-5 inline-flex w-fit" data-id="element-751" data-mp="2fteorijrkr46">
              <UsersIcon className="h-6 w-6 text-[#004AC7]" data-id="element-752" data-mp="2fvhoiuapxym3" />
            </div>
            <h3 className="font-bold text-[#111827] mb-3 text-lg leading-tight" data-id="element-753" data-mp="2ku2qoz9j6sd6">
              Niet meer afhankelijk van via via
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed mb-6 flex-grow" data-id="element-754" data-mp="28a5rgnoj8ivh">
              Structureel nieuwe klanten aantrekken via bewezen online kanalen.
              Voorspelbaar en schaalbaar.
            </p>
            <a href="#services" className="inline-flex items-center text-[#004AC7] font-semibold text-sm hover:text-[#003A9E] transition-colors group mt-auto" data-id="element-755" data-mp="2haan60kd5stt">
              Hoe wij dat doen
              <ArrowRightIcon className="ml-1.5 h-4 w-4 transform group-hover:translate-x-1 transition-transform" data-id="element-756" data-mp="1omest2i9od07" />
            </a>
          </motion.div>

          {/* Card 3 - SEO zonder giswerk */}
          <motion.div variants={itemVariants} whileHover={{
          y: -5,
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
        }} className="bg-white rounded-xl p-6 shadow-lg transition-all duration-300 flex flex-col h-full border border-gray-100" data-id="element-757" data-mp="1yjkhy57bltxs">
            <div className="bg-[#EEF5FA] rounded-lg p-3 mb-5 inline-flex w-fit" data-id="element-758" data-mp="94tayrf957pv">
              <SearchIcon className="h-6 w-6 text-[#004AC7]" data-id="element-759" data-mp="e2v5c8i4otgn" />
            </div>
            <h3 className="font-bold text-[#111827] mb-3 text-lg leading-tight" data-id="element-760" data-mp="e0qq4ues4812">
              SEO die wél converteert
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed mb-6 flex-grow" data-id="element-761" data-mp="mvoo4fwsaaz9">
              Geen duur SEO-pakket op basis van aannames. Wij bouwen je online
              aanwezigheid op data die bewezen converteert.
            </p>
            <a href="/seo" className="inline-flex items-center text-[#004AC7] font-semibold text-sm hover:text-[#003A9E] transition-colors group mt-auto" data-id="element-762" data-mp="ws1izh42euvl">
              Bekijk onze aanpak
              <ArrowRightIcon className="ml-1.5 h-4 w-4 transform group-hover:translate-x-1 transition-transform" data-id="element-763" data-mp="15szj3obdui8w" />
            </a>
          </motion.div>

          {/* Card 4 - SBB Erkend Leerbedrijf */}
          <motion.div variants={itemVariants} whileHover={{
          y: -5,
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
        }} className="bg-white rounded-xl p-6 shadow-lg transition-all duration-300 flex flex-col items-center justify-center h-full border border-gray-100" data-id="element-764" data-mp="37m5wzzbfrmg4">
            <img src="https://cdn.magicpatterns.com/uploads/1aHtpkWESLeaWQNYKA51qz/WhatsApp_Image_2026-02-28_at_14.34.29.jpg" alt="S-BB Erkend Leerbedrijf" className="w-full max-w-[180px] h-auto object-contain mb-6" data-id="element-765" data-mp="2q9yz9jb9b4kj" />
            <a href="/sollicitatie" className="inline-flex items-center justify-center w-full bg-[#004AC7] text-white font-semibold py-3 px-4 rounded-lg hover:bg-[#003A9E] transition-colors mt-auto" data-id="element-766" data-mp="3e25ugf58x5id">
              Bekijk vacatures
              <ArrowRightIcon className="ml-1.5 h-4 w-4 transform group-hover:translate-x-1 transition-transform" data-id="element-767" data-mp="3506dfmu8e1ff" />
            </a>
          </motion.div>
        </motion.div>
      </div>
    </div>;
};